export default class BillMultiple {
  act(tasks, vue, callback) {
    vue.$root.$emit('bill-tasks', tasks)
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/views/agenda/MultipleSelectActions/BillMultiple.js